import { render, staticRenderFns } from "./ErrorLogList.vue?vue&type=template&id=66599c7a&scoped=true"
import script from "./ErrorLogList.vue?vue&type=script&lang=js"
export * from "./ErrorLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66599c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66599c7a')) {
      api.createRecord('66599c7a', component.options)
    } else {
      api.reload('66599c7a', component.options)
    }
    module.hot.accept("./ErrorLogList.vue?vue&type=template&id=66599c7a&scoped=true", function () {
      api.rerender('66599c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/errorlog/ErrorLogList.vue"
export default component.exports